import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import { getPlatformDetails, getFeedbackList, getKpiList, getClientList } from '../utils/Api';
import { formatFeedbackList, exportFeedbackFile, formatkpiList, formatClientList, exportClientFile, exportKpiFile } from '../utils/DownloadFeedback';

import ReactPaginate from 'react-paginate';
import PlatformClient from './PlatformClient';

import { handleLoaderEvent } from '../utils/LoaderEmitter';
import { Image } from '@fluentui/react-northstar';
import { iconAssets } from '../assets/theme/theme';

import '../styles/PlatformDashboard.css';

const renderClientDetails = (clientDetails, setClientDetails) => {

  const handleUpdateEvent = async () => {
    handleLoaderEvent.emit('loader', true);
    setClientDetails([]);
    let clientDetailsResponse = await getClientList();
    if (!clientDetailsResponse) {
      return;
    }
    setClientDetails(clientDetailsResponse);
    handleLoaderEvent.emit('loader', false);
  }

  let clientRenderDetails = [];
  clientDetails?.forEach((client) => {
    clientRenderDetails.push(
      <PlatformClient key={client.customerId} client={client} onUpdateEvent={handleUpdateEvent}></PlatformClient>
    )
  });

  return clientRenderDetails;
};

const downloadFeedback = async () => {
  let feedbackList = await getFeedbackList();
  if (feedbackList) {
    const formatedDetails = await formatFeedbackList(feedbackList);
    exportFeedbackFile(formatedDetails);
  }
}

const downloadKpi = async () => {
  let kpiList = await getKpiList();
  if (kpiList) {
    const formatedDetails = await formatkpiList(kpiList);
    exportKpiFile(formatedDetails);
  }
}

const downloadClient = async () => {
  let clientList = await getClientList();
  if (clientList) {
    const formatedDetails = await formatClientList(clientList);
    exportClientFile(formatedDetails);
  }
}

const PlatformDashboard = () => {

  const [platformDetails, setPlatformDetails] = useState({});
  const [clientDetails, setClientDetails] = useState([]);

  const [itemsPerPage, setitemsPerPage] = useState(5)
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState(null);

  const rowsPerPage = 5;
  const pageNumber = 1;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(clientDetails.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(clientDetails.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, clientDetails]);

  useEffect(() => {
    (async () => {
      let platformResponse = await getPlatformDetails();
      if (!platformResponse) {
        return;
      }
      setPlatformDetails(platformResponse);
      let clientResponse = await getClientList(rowsPerPage, pageNumber);
      if (!clientResponse) {
        return
      }
      setClientDetails(clientResponse);
    })();
  }, []);

  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % clientDetails.length;
    setItemOffset(newOffset);
  };

  return (
    <div>
      <div className='row p-0 m-0 w-100'>
        <div className='col-auto ps-0 pe-2'>
          <button className='breadcrumbs-button'>Dashboard</button>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to="/master-skills"><button className='breadcrumbs-button-outline'>Manage Skills</button></Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to="/new-client"><button className='breadcrumbs-button-outline'>Add Client</button></Link>
        </div>
      </div>
      <div className='row p-0 m-0 w-100 mt-4'>
        <div className='col-4 p-0'>
          <div className='row p-0 m-0 w-100'>
            <div className='col-auto ps-0 card-text d-flex align-items-center'>
              Total no of clients
            </div>
            <div className='col-auto card-content d-flex justify-content-center align-items-center'>
              {platformDetails?.totalCustomers}
            </div>
          </div>
        </div>
        <div className='col-4 p-0'>
          <div className='row p-0 m-0 w-100 d-flex justify-content-center'>
            <div className='col-auto ps-0 card-text d-flex align-items-center'>
              Total no of Licenses
            </div>
            <div className='col-auto card-content d-flex justify-content-center align-items-center'>
              {platformDetails?.totalLicense}
            </div>
          </div>
        </div>
        <div className='col-4 p-0'>
          <div className='row p-0 m-0 w-100 d-flex justify-content-end'>
            <div className='col-auto ps-0 card-text d-flex align-items-center'>
              Total no of Active Licenses
            </div>
            <div className='col-auto card-content d-flex justify-content-center align-items-center'>
              {platformDetails?.totalActiveLicenses}
            </div>
          </div>
        </div>
      </div>
      <div className='client-list mt-4'>
        <table className='w-100'>
          <thead className="table-head">
            <tr>
              <th className='p-1'>Account Name</th>
              <th className='p-1'>Client Name</th>
              <th className='p-1'>Admin Name</th>
              <th className='p-1'>Total Licenses</th>
              <th className='p-1'>Active Licenses</th>
              <th className='p-1'>Status</th>
              <th className='p-1'>Actions</th>
              <th className='p-1'>Notification</th>
            </tr>
          </thead>
          <tbody>
            {renderClientDetails(currentItems, setClientDetails)}
          </tbody>
        </table>
      </div>
      <div className='row p-0 m-0 mt-4'>
        <div className='col-auto px-2 d-flex align-items-center'>
          Rows Per Page
        </div>
        <div className='col-auto px-2 d-flex align-items-center'>
          <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            {itemsPerPage}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><div className="dropdown-item" onClick={() => setitemsPerPage(5)}>5</div></li>
            <li><div className="dropdown-item" onClick={() => setitemsPerPage(10)}>10</div></li>
          </ul>
        </div>
        <div className='col p-0 d-flex justify-content-end'>
          <ReactPaginate nextLabel=">" onPageChange={handlePageClick} pageRangeDisplayed={4} marginPagesDisplayed={2} pageCount={pageCount} previousLabel="<" pageClassName="page-item" pageLinkClassName="page-link" previousClassName="page-item" previousLinkClassName="page-link" nextClassName="page-item" nextLinkClassName="page-link" breakLabel="..." breakClassName="page-item" breakLinkClassName="page-link" containerClassName="pagination" activeClassName="active" renderOnZeroPageCount={null} />
        </div>
      </div>
      <div className='row p-0 m-0 w-100 mt-5'>
        <div className='col p-0'>
        </div>
        {/* <div className='col-auto p-0'>
          <Link to="/new-client">
            <div className='row p-0 m-0 cursor-pointer'>
              <div className='col-auto p-0 d-flex align-items-center'>
                <Image src={iconAssets.add} alt="" className="add-icon" />
              </div>
              <div className='col-auto ps-2 add-text d-flex align-items-center'>
                Add
              </div>
            </div>
          </Link>
        </div> */}
      </div>
    </div>
  )
}

export default PlatformDashboard